import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import {
  CreditCardNetwork,
  DisplayCards,
} from "chameleon/lib/components/display-cards/display-cards";
import { PaymentMethodTitle } from "chameleon/lib/components/payment-method-title/payment-method-title";

import { CardNetwork } from "frontend-client";

type PazePaymentMethodProps = {
  last4?: string;
  network?: string | CardNetwork;
  trailingSlot?: ReactElement;
};

export const PazePaymentMethod = ({
  last4,
  network,
  trailingSlot,
}: PazePaymentMethodProps) => {
  const { t } = useTranslation("combined");

  let CardIcon;
  if (network) {
    switch (network) {
      case "VISA":
        CardIcon = "visa";
        break;
      case "MASTERCARD":
        CardIcon = "mastercard";
        break;
    }
  }
  const creditCardTitle = t("creditCardEnding", {
    number: last4,
    cardNetwork: CardIcon
      ? t(`checkoutForm.cardNumber.cardNames.${CardIcon}`)
      : "",
  });

  return (
    <PaymentMethodTitle
      trailingSlot={trailingSlot}
      leadingSlot={
        <DisplayCards
          isPaymentNameWithIcon={true}
          supportedPaymentTypes={
            CardIcon ? [CardIcon as CreditCardNetwork] : []
          }
        />
      }
      title={creditCardTitle}
    />
  );
};
